<template>
  <div class="sidebar">
    <SideTemplate :show="show" @sidebartoggle="sidebarToggle">
      <template v-slot:default>
        <div class="flex nowrap">
          <router-link class="link" to="/dashboard"><img class="icon" src="../../../public/assets/icons/dashboard.svg" />{{ $t("message.dashboard") }}</router-link>
        </div>
        <div class="flex nowrap">
          <router-link class="link" :to="{ name: 'details' }"><img class="icon" src="../../../public/assets/icons/events.svg" />{{ $t("message.events") }}</router-link>
        </div>
        <div class="flex nowrap">
          <router-link class="link" to="/stats"><img class="icon" src="../../../public/assets/icons/stats.svg" />{{ $t("message.statistics") }}</router-link>
        </div>
        <!-- <div class="flex nowrap">
          <router-link class="link" to="/rails"
            ><img class="icon" src="../../../public/assets/icons/stats.svg" />{{
              'Rails'
            }}</router-link
          >
        </div> -->
      </template>

      <template v-slot:footer>
        <div class="flex nowrap" @click="monitorToggle">
          <a class="noselect flex"><img class="icon" src="../../../public/assets/icons/status.svg" />{{ $t("message.statusMonitor") }}</a>
        </div>
        <div class="flex nowrap" @click="analogNodeToggle" v-if="adminRights && hasAnalogNode && !isLambro">
          <a class="noselect flex"><img class="icon" src="../../../public/assets/icons/settings.svg" />Analog Node</a>
        </div>
        <div class="flex nowrap" @click="settingsToggle" v-if="adminRights">
          <a class="noselect flex"><img class="icon" src="../../../public/assets/icons/settings.svg" />{{ $t("message.settings") }}</a>
        </div>
      </template>
    </SideTemplate>
  </div>
</template>
<script>
import SideTemplate from "./SideTemplate";
export default {
  name: "sidebar",
  components: {
    SideTemplate,
  },
  methods: {
    sidebarToggle: function () {
      this.$emit("sidebartoggle");
    },
    settingsToggle: function () {
      this.$emit("settingstoggle");
    },
    analogNodeToggle: function () {
      this.$emit("analog-node-toggle");
    },
    monitorToggle: function () {
      this.$emit("monitortoggle");
    },
  },
  props: {
    show: Boolean,
    adminRights: Boolean,
    sensors: Array,
  },
  computed: {
    hasAnalogNode() {
      return this.sensors && this.sensors.find((s) => s.type === "analog-node");
    },
    isLambro() {
      return this.sensors ? this.sensors.some((sn) => sn.eui === "C0EE400001015144") : false;
    },
  },
};
</script>
<style scoped>
.router-link-active {
  background-color: rgb(32, 34, 47);
  color: white !important;
}

/* Icone bianche se sono su quella route */
.router-link-active > img {
  filter: brightness(0) invert(1);
}

.icon {
  padding-left: 10px;
  padding-right: 10px;
}
</style>
